module.exports = __webpack_public_path__ + "img/bespoke70_05.ad285bdd.jpg";